import {
  ByteParameters,
  DeviceData,
  DeviceStatus,
  DeviceTab
} from "./Device.model";

export class DeviceUtils {
  static buildDeviceTabUrl(deviceId: string | undefined, tabKey: DeviceTab): string {
    return tabKey === "main"
      ? `/devices/${deviceId}`
      : `/devices/${deviceId}?tab=${tabKey}`;
  }

  static getIsNewVersion(firmwareVersion?: string | null): boolean {
    if (!firmwareVersion) {
      return false;
    }

    const trimmedVersion = firmwareVersion.trim();
    const regexResult = /.*\s(?<major>\d+)\.(?<minor>\d+)\.(?<fix>\d+).*$/.exec(trimmedVersion);

    if (!regexResult || !regexResult.groups) {
      return false;
    }

    const { major, minor } = regexResult.groups;
    const majorVersion = Number(major);
    const minorVersion = Number(minor);

    return majorVersion > 11 || (majorVersion === 11 && minorVersion >= 10);
  }

  static enrichDevice(
    device: DeviceData,
    status: DeviceStatus | null | undefined,
    dawnTime: string,
    duskTime: string
  ): DeviceData {
    return {
      ...device,
      dawnTime: dawnTime,
      duskTime: duskTime,
      isConnected: status?.isConnected || false,
      isLoading: false
    };
  }

  static enrichDeviceWithFallback(device: DeviceData): DeviceData {
    return {
      ...device,
      dawnTime: {hours: 0, minutes: 0},
      duskTime: {hours: 0, minutes: 0},
      isConnected: false,
      isLoading: false
    };
  }

  static getSelectedDeviceForPanel(
    isAdmin: boolean | null,
    availableDevices: DeviceData[],
    device: DeviceData | null
  ): DeviceData | null {
    return isAdmin ? availableDevices[0] || device : device;
  }

  static buildBase64StringFromBytes(parameters: ByteParameters): string {
    let binary = "";
    const bytes = new Uint8Array(parameters);
    const len = bytes.byteLength;

    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }

    return btoa(binary);
  }
}
